import { DeviceEventEmitter } from "react-native";

import ElginModule from "./ElginModule";

export default class ElginPayService{

    elginModule;

    constructor() {
        this.elginModule = ElginModule; // NativeModules.ToastModules;
    }

    sendFunctionToAndroid(mapParam){
        this.elginModule.sendOptionElginPay(mapParam);
    };

    sendCreditPayment(valor,installmentType){
        const mapParam = {
            "typeTransition":"creditTransaction",
            "value": valor,
            "installment": installmentType,
        }

        this.sendFunctionToAndroid(mapParam);
    }
    sendDebitPayment(valor){
        const mapParam = {
            "typeTransition":"debitTransaction",
            "value": valor,
        }

        this.sendFunctionToAndroid(mapParam);
    }

    sendAdmTransaction(){
        const mapParam={
            "typeTransition":"admTransaction"
        }

        this.sendFunctionToAndroid(mapParam);
    }

    sendCancelSell(valor){
        const mapParam = {
            "typeTransition":"cancelTransaction",
            "value": valor,
        }

        this.sendFunctionToAndroid(mapParam);
    }

    doElginPay = async (paymentType, value) => {
        return new Promise((resolve, reject) => {
            if (paymentType === 'credit') {
                this.sendCreditPayment(value.toFixed(2), "0");
            } else {
                if (paymentType === 'debit') {
                    this.sendDebitPayment(value.toFixed(2));
                }
            }
            let actualEvent = DeviceEventEmitter.addListener('elginPayReturn', event => {
                const result = JSON.parse(event.paymentStatus);
                actualEvent.remove();
                resolve(result.resultadoTransacao);
            });
        });
    }
}